<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary h4 text-center">
          <linkto :link="'/'"/>
          Ügyfelek teljes lista
      </div>
    </div>
    <div class="m-1">
      <div class="mui-textfield mui-textfield">
        <input type="text" v-model="search">
        <label>Név / Cím keresés</label>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Régió</th>
            <th scope="col">Név</th>
            <th scope="col">Ir</th>
            <th scope="col">Város</th>
            <th scope="col">Cím</th>
            <th scope="col">Módosít</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in customers" :key="index" :class="[item.aktiv === `1` ? 'table-success' : '']">
            <td>{{item.id}}</td>
            <td>{{item.regio}}</td>
            <td>{{item.nev}}</td>
            <td>{{item.iszam}}</td>
            <td>{{item.varos}}</td>
            <td>{{item.cim}}</td>
            <td>
              <router-link
                :to="`/customer/${item.id}`"
              >
                Módosít
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'customers',
  components: {
  },
  data () {
    return {
      page_count: 0,
      perpage: 25,
      page: null,
      search: ``
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    load(){
      this.$Progress.start()
      this.req.post(`/customers`)
        .then(res => {
          this.$store.dispatch('setcustomers', res.data.customers)
          this.$Progress.finish()
        })
        .catch(err => {
          console.log(err)
          this.$Progress.fail()
        })
    }
  },
  computed: {
  	customers(){
      if (this.$store.getters.customers === null) return
  		return this.$store.getters.customers.filter(c => {
        if(c.nev.includes(this.search)) {
          return c
        } else if (c.varos.includes(this.search)) {
            return c
        }
      })
  	}
  }
}
</script>

<style scoped>
.table {
    font-size: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customers/customers.vue